
import getProductDataQuery from '~/graphql/products/queries/getProductRecently.graphql'

export default {
  name: 'ProductContainerPhysical',

  props: {
    product: {
      type: Object,
      required: true,
    },

    productReviews: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {
      recentlyViewed: null,
      productRecentlyViewed: [],
    }
  },

  computed: {
    // zrob to zajebiscie szybko a po nowym roku sie poprawi (c) Milosz 06.12.2024
    isGiftCardProduct () {
      return (/Wirtualna Karta Podarunkowa|Virtual .* Gift Card/i).test(this.product.name)
    },
  },

  mounted () {
    const existingProduct = localStorage.getItem('storage-recently-viewed-product')

    this.recentlyViewed = existingProduct ? JSON.parse(existingProduct) : []
    this.getProductData(this.recentlyViewed.value)
  },

  methods: {
    async getProductData (items) {
      const itemsWithoutNull = items.filter(item => item !== null)

      await this.$graphql({
        requestPayload: {
          query: getProductDataQuery,
          variables: {
            filter: {
              url_key: {
                in: itemsWithoutNull,
              },
            },
          },
          useGETForQueries: true,
          context: {
            fetchOptions: {
              method: 'GET',
            },
          },
        },
        successHandler: ({ data: { products: { items } } }) => {
          this.productRecentlyViewed = items
        },
      })
    },
  },
}
